import axios from "axios";

export default function getIntegrationSetting() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/account/api/v1/dksh-integration-settings`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
